<template>
  <div class="mini-n" :style="{ background, color, maxWidth }">
    <slot name="default"></slot>
  </div>
</template>

<script>
export default {
  name: 'MiniNotification',
  props: {
    color: { type: String, default: '#ad9853' },
    background: { type: String, default: 'linear-gradient(180deg, rgba(249, 230, 166, 0.50) 0%, rgba(249, 235, 188, 0.50) 100%)' },
    maxWidth: { type: String, default: 'max-content' },
  }
}
</script>

<style scoped>
.mini-n {
  padding: 7px 10px;
  border-radius: 8px;
}
</style>